import {
  replaceIndex,
  deleteIndex,
  replaceObjectKey
} from "../../../../helpers/JSONTransformations";

const useVariantsTableManipulation = ({
  columns,
  rows,
  setRows,
  setColumns,
  blankRow,
  checkForDuplicateTitleIndices
}) => {
  const onChangeInput = (key, rowIndex) => ({ target: { value } }) => {
    const parsedValue =
      key === "stock"
        ? !isNaN(parseInt(value))
          ? parseInt(value)
          : ""
        : value;

    setRows(
      replaceIndex(rows, rowIndex, {
        ...rows[rowIndex],
        [key]: parsedValue
      })
    );
  };

  const addVariant = () => setRows([...rows, blankRow]);

  const deleteVariant = (rowIndex) =>
    rows.length !== 1 && setRows(rows.filter((row, i) => i !== rowIndex));

  const addVariantOption = () => {
    setColumns([
      ...columns,
      {
        title: "",
        placeholder: "Option Value",
        stateKey: `variantOption${columns.length}`,
        variantOption: true
      }
    ]);
    setRows(
      rows.map((row) => ({ ...row, [`variantOption${columns.length}`]: "" }))
    );
  };

  const onChangeVariantOptionTitle = (columnIndex) => (newTitle) => {
    const newColumns = replaceIndex(columns, columnIndex, {
      ...columns[columnIndex],
      title: newTitle
    });

    checkForDuplicateTitleIndices(newColumns);

    setColumns(newColumns);
  };

  const getVariantOptionTitle = (columnIndex) =>
    columns.find((column) => column.stateKey === `variantOption${columnIndex}`)
      .title;

  const deleteVariantOption = (columnIndexToDelete) => {
    const rowsWithoutDeletedColumn = rows.map(
      ({ [columns[columnIndexToDelete].stateKey]: deleted, ...row }) => row
    );
    setColumns(
      deleteIndex(columns, columnIndexToDelete).map((column, columnIndex) => {
        if (column.stateKey.includes("variantOption")) {
          setRows(
            rowsWithoutDeletedColumn.map((row) =>
              replaceObjectKey(
                row,
                column.stateKey,
                `variantOption${columnIndex}`
              )
            )
          );
          return {
            ...column,
            stateKey: `variantOption${columnIndex}`
          };
        }

        return column;
      })
    );
  };

  return {
    onChangeInput,
    addVariant,
    deleteVariant,
    addVariantOption,
    onChangeVariantOptionTitle,
    getVariantOptionTitle,
    deleteVariantOption
  };
};

export default useVariantsTableManipulation;
